const isError = (error: unknown): error is Error => {
  return error instanceof Error;
}

const ErrorHelpers = {
  isError
}

export default ErrorHelpers
